import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';

// eslint-disable-next-line require-await
export default [
  {
    // Supervisor Approval
    path: '/advisor/supervisor-approval',
    name: 'SupervisorApproval',
    component: () => import('@advisor/components/supervisorApproval/supervisorApproval'),
    meta: {
      breadCrumbs: {
        to: '/advisor/supervisor-approval',
        text: '',
        title: 'Account Opening Supervision',
        componentId: COMPONENT_ID.ADO_SUPERVISOR_APPROVAL,
      },
      riaComponent: RIA_COMPONENT.ADO_SUPERVISOR_APPROVAL,
      platformArea: PLATFORM_AREA.ADO_SUPERVISOR_APPROVAL,
      visibilityComponentId: COMPONENT_ID.ADO_SUPERVISOR_APPROVAL,
    },
  },
];
